import React, { useEffect, useMemo, useState } from "react";

const CELL_SIZE = 88;
const RANDOM_ACTIVE_COUNT = 8;
const RANDOM_REFRESH_MS = 1150;

// Iconic meme “hall of fame” — 50 full GIF URLs (Tenor + Giphy). Curated for
// instant recognition; swap anytime. Verify: curl -I "<url>"
const ICONIC_MEME_GIF_URLS: string[] = [
  // —— Core internet classics ——
  "https://media.tenor.com/pXe-GokoyA0AAAAM/the-s-impsons-bush.gif", // Homer → bushes
  "https://media.tenor.com/DZ6Eirck_dwAAAAM/drake-hotline-bling.gif", // Drake Hotline Bling
  "https://media.tenor.com/ZhKMg4_yCTgAAAAM/surprised-pikachu.gif", // Surprised Pikachu
  "https://i.giphy.com/media/z9AUvhAEiXOqA/giphy.gif", // This is fine (classic Giphy)
  "https://media.tenor.com/2aTLTkjCH2IAAAAM/nope-no-god-please-no.gif", // Michael Scott “no god”
  "https://media.tenor.com/qScpQ8cwnZsAAAAM/leonardo-dicaprio-cheers.gif", // Leo toast / Great Gatsby
  "https://media.tenor.com/eBByy4ihCocAAAAM/angry-fist.gif", // Arthur fist
  "https://media.tenor.com/S2HoKR960dYAAAAM/imagination-spongebob.gif", // SpongeBob “imagination”
  "https://media.tenor.com/EmowQvINECIAAAAM/taylor-armstrong-smudge-cat.gif", // Woman yelling at cat / Smudge
  "https://media.tenor.com/hNKtx3B6JIYAAAAM/distracted-boyfriend-distracted-boyfriend-meme.gif", // Distracted boyfriend
  "https://media.tenor.com/f5TnJ6l0li0AAAAM/stonks.gif", // Stonks
  "https://media.tenor.com/wTdVILsqVK4AAAAM/michael-jordan-mj.gif", // Crying Jordan
  "https://media.tenor.com/RQBEbdhoiC4AAAAM/standing-back-of-party.gif", // “They don’t know”
  "https://media.tenor.com/YZmaj_qzJrsAAAAM/rickroll.gif", // Rickroll
  "https://media.tenor.com/92fv6uBxxNQAAAAM/john-travolta.gif", // Confused Travolta
  "https://media.tenor.com/xBk3W_f99MIAAAAM/is-this-a-pigeon-butterfly.gif", // Is this a pigeon?
  "https://media.tenor.com/TGH9iMkYiDgAAAAM/galaxy-brain.gif", // Galaxy brain
  "https://media.tenor.com/xbddlZTRNVwAAAAM/deal-with.gif", // Deal with it
  "https://media.tenor.com/HZXfyChezEcAAAAM/evil-kermit-evil-kermit-meme.gif", // Evil Kermit
  "https://media.tenor.com/FZDmqDyLcrAAAAAM/kermit-the-frog-tea.gif", // Kermit tea / none of my business
  "https://i.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif", // Keyboard Cat
  "https://i.giphy.com/media/8CFKqeK9vks3C/giphy.gif", // Grumpy Cat
  // —— More hall-of-fame (TV, film, web, politics-of-mittens) ——
  "https://media.tenor.com/5aQ2kLJuQuUAAAAM/oprah-you.gif", // Oprah “you get a car”
  "https://media.tenor.com/A-zZf6j_uvwAAAAM/omni-man-you-should-have-died-at-birth.gif", // Think, Mark
  "https://media.tenor.com/FXbv5JZwFj0AAAAM/doge-doge-meme.gif", // Doge
  "https://media.tenor.com/VNmtoA4hXzEAAAAM/sit-bernie-mitts.gif", // Bernie mittens
  "https://media.tenor.com/wrsTYNGompoAAAAM/wadz-disaster-girl.gif", // Disaster Girl
  "https://media.tenor.com/Ojtb4GSGngcAAAAM/successful-child.gif", // Success Kid
  "https://media.tenor.com/5qsfAizaagoAAAAM/ddalwayssunny-charlie-day.gif", // Charlie conspiracy board
  "https://media.tenor.com/O-1tbwmyK4YAAAAM/futurama-fry.gif", // Shut up and take my money
  "https://media.tenor.com/fi5CGUkQgzcAAAAM/star-trek-the-next-generation-captain-picard-facepalm-double-facepalm-picard-facepalm.gif", // Picard facepalm
  "https://media.tenor.com/vMGAIIplyHAAAAAM/i-understood-that-reference-understood-that.gif", // Cap “I understood that reference”
  "https://media.tenor.com/iK4wLjKgVFAAAAAM/lord-of-the-rings-boromir.gif", // One does not simply
  "https://media.tenor.com/zo4BviPIso0AAAAM/300-leonidas.gif", // This is Sparta
  "https://media.tenor.com/vx3rDqbJFlAAAAAM/spiderman-spiderman-meme.gif", // Spider-Man pointing
  "https://media.tenor.com/3ySbY2xHpBMAAAAM/aliens.gif", // Ancient Aliens guy
  "https://media.tenor.com/xNvXeMzXgmgAAAAM/confused-math-lady-lady-with-equations-meme.gif", // Confused math lady
  "https://media.tenor.com/nWb8HjZbnJ4AAAAM/smart-think.gif", // Roll Safe
  "https://media.tenor.com/kSCYSXqEnakAAAAM/spongebob-squarepants-squidward-tentacles.gif", // Squidward future
  "https://media.tenor.com/1EdlGzkwMLsAAAAM/evil-laugh-rub-hands.gif", // Evil Patrick
  "https://media.tenor.com/rec5dlPBK2cAAAAM/mr-bean-waiting.gif", // Mr. Bean waiting
  "https://media.tenor.com/wRukFkpTONkAAAAM/anchorman-news-team.gif", // Anchorman
  "https://media.tenor.com/0C4oWnAK16YAAAAM/ron-burgundy-will-ferrell.gif", // That escalated quickly
  "https://media.tenor.com/sieGamJMkB0AAAAM/matrix-dodge.gif", // Matrix bullet dodge
  "https://media.tenor.com/Djldnyx1-goAAAAM/arnold-schwarzenegger-the-terminator.gif", // I’ll be back
  "https://media.tenor.com/FD1_LNK836oAAAAM/pivot-friends.gif", // Friends PIVOT
  "https://media.tenor.com/lJaMNchLJO0AAAAM/the-simpsons-nelson-muntz.gif", // Nelson ha-ha
  "https://media.tenor.com/HA2ennVsLV8AAAAM/i-am-the-one-who-knocks-breakingbad.gif", // I am the one who knocks
  "https://media.tenor.com/aqJtlg68BTQAAAAM/breakingbad-science.gif", // Yeah science (Jesse)
  "https://media.tenor.com/QvQPQCnw5-0AAAAM/my-precious-gollum.gif", // My precious
];

const memeGifIndexForCell = (index: number, col: number, row: number) => {
  let h =
    index * 92837111 +
    col * 48271 +
    row * 31337 +
    (col ^ row) * 1315423911 +
    col * row * 17;
  h ^= h >>> 13;
  h ^= h << 17;
  h ^= h >>> 5;
  const n = ICONIC_MEME_GIF_URLS.length;
  return (Math.abs(h) % n + n) % n;
};

type GridPointer = {
  col: number;
  row: number;
} | null;

type TrailCell = {
  id: number;
  strength: number;
};

const CookieBackground: React.FC = () => {
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [activeCells, setActiveCells] = useState<Set<number>>(new Set());
  const [hoveredCell, setHoveredCell] = useState<GridPointer>(null);
  const [trailCells, setTrailCells] = useState<TrailCell[]>([]);

  const grid = useMemo(() => {
    const cols = Math.ceil(viewport.width / CELL_SIZE);
    const rows = Math.ceil(viewport.height / CELL_SIZE);
    return { cols, rows, total: cols * rows };
  }, [viewport]);

  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const randomizeCells = () => {
      const next = new Set<number>();
      const targetCount = Math.min(RANDOM_ACTIVE_COUNT, grid.total);

      while (next.size < targetCount) {
        next.add(Math.floor(Math.random() * grid.total));
      }

      setActiveCells(next);
    };

    randomizeCells();
    const intervalId = window.setInterval(randomizeCells, RANDOM_REFRESH_MS);

    return () => window.clearInterval(intervalId);
  }, [grid.total]);

  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    const col = Math.floor(x / CELL_SIZE);
    const row = Math.floor(y / CELL_SIZE);
    const cellId = row * grid.cols + col;

    setHoveredCell({ col, row });
    setTrailCells((current) => {
      const next = current
        .filter((cell) => cell.id !== cellId)
        .map((cell) => ({
          ...cell,
          // Slower, gentler decay for a smoother fade-out trail
          strength: Math.max(cell.strength - 0.12, 0),
        }))
        .filter((cell) => cell.strength > 0.04);

      // Keep a slightly longer trail for visual continuity
      return [{ id: cellId, strength: 1 }, ...next].slice(0, 9);
    });
  };

  const handlePointerLeave = () => {
    setHoveredCell(null);
    setTrailCells([]);
  };

  return (
    <div
      className="absolute inset-0 overflow-hidden bg-black"
      onPointerMove={handlePointerMove}
      onPointerLeave={handlePointerLeave}
      style={{ zIndex: 0 }}
    >
      <div
        className="absolute inset-0"
        style={{ background: "#000" }}
      />

      <div
        className="absolute inset-0"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${grid.cols}, minmax(0, 1fr))`,
          gridTemplateRows: `repeat(${grid.rows}, minmax(0, 1fr))`,
        }}
      >
        {Array.from({ length: grid.total }).map((_, index) => {
          const col = index % grid.cols;
          const row = Math.floor(index / grid.cols);
          const isHovered =
            hoveredCell?.col === col && hoveredCell?.row === row;
          const isActive = activeCells.has(index);
          const trailMatch = trailCells.find((cell) => cell.id === index);
          const trailStrength = trailMatch?.strength ?? 0;
          const isTrail = trailStrength > 0;

          const memeGif =
            ICONIC_MEME_GIF_URLS[memeGifIndexForCell(index, col, row)];

          const baseBackground = isActive
            ? "rgba(255,255,255,0.072)"
            : "rgba(255,255,255,0.015)";

          // Trail cells: ghosted meme GIF that fades with strength
          const clampedStrength = Math.max(0, Math.min(1, trailStrength));
          const trailOverlayAlpha = 0.65 - clampedStrength * 0.3;

          const usesGif = isHovered || isTrail;

          const background = isHovered
            ? `url(${memeGif}) center center / cover no-repeat`
            : isTrail
              ? `linear-gradient(rgba(0,0,0,${trailOverlayAlpha}), rgba(0,0,0,${trailOverlayAlpha})), url(${memeGif}) center center / cover no-repeat`
              : baseBackground;

          return (
            <div
              key={index}
              style={{
                borderRight: "1px solid rgba(255,255,255,0.025)",
                borderBottom: "1px solid rgba(255,255,255,0.025)",
                background,
                opacity: 1,
                // Monochrome treatment for hover/trail so GIFs read on the grid.
                filter: usesGif
                  ? "grayscale(1) contrast(1.1) brightness(0.96)"
                  : "none",
                transition:
                  "background-color 1100ms cubic-bezier(0.22, 1, 0.36, 1), background-image 520ms ease-out, transform 900ms cubic-bezier(0.22, 1, 0.36, 1)",
                transform: isHovered
                  ? "scale(1.01)"
                  : isTrail || isActive
                    ? "scale(1.004)"
                    : "scale(1)",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CookieBackground;
